
import { MainListComponent }  from '../SmallComponents/SmallListComponent'
 
const CustomerCandidatesComponent = () => {
     
    return (
        <MainListComponent openAsDialog={false}  defaultFilterValue="active" type="customercandidate" />
    ) 
}
export {CustomerCandidatesComponent}